import { useEffect } from "react";
import { doGetMsGraphUserByEmail } from "../admin/restQueries";
import { ReportChaptersTreeDemo } from "../../../components/ReportChapterTree/ReportChaptersTreeDemo";

const Apptest = () => {
  useEffect(() => {
    async function fetch() {
      await doGetMsGraphUserByEmail("tobiasnorum.andersson@multiconsult.no");
      //   await doGetBimObjectsByFloor("5c88d216dbb10a37c75aa7af", "60c1db8e8605fe14e94a89b1", "1YMMGxlDD9DgoKadlajFce");
    }
    fetch();
  }, []);

  return (
    <div style={{ overflow: "auto", height: "100vh" }}>
      hello test
      <ReportChaptersTreeDemo />
    </div>
  );
};

export default Apptest;
